import * as React from 'react';
import { Layout } from '../../components/Layout';
import { DataTable } from '../../components/DataTable';
import { RouteModal } from '../../components/RouteModal';
import template from './DataTemplate';
import { useGetAdsQuery } from '../../../services/gmoOfferwallApi';
import AddForm from './AddForm';
import EditForm from './EditForm';
import useFilterQuery from '../../../utils/customHooks/useFilterQuery';

export function OfferwallPage() {
  const {
    fieldFilter,
    setFieldFilter,
    search,
    setSearch,
    order,
    setOrder,
    orderBy,
    setOrderBy,
  } = useFilterQuery(template);
  const { data = [], isLoading, error, isError } = useGetAdsQuery();

  return (
    <Layout title={'案件管理'}>
      <DataTable
        title={'案件管理'}
        data={data}
        loading={isLoading}
        error={error}
        isError={isError}
        template={template}
        fieldFilter={fieldFilter}
        search={search}
        setFieldFilter={setFieldFilter}
        setSearch={setSearch}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
      />
      <RouteModal addForm={<AddForm />} editForm={<EditForm />} />
    </Layout>
  );
}

export default OfferwallPage;
